import * as React from 'react';

import type { IconProps } from '../types';

const StatusReady = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 16, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        aria-hidden="true"
        {...props}
      >
        <path
          fill="hsl(var(--twc-status-icon-ready))"
          d="M7.99366 1.51907C7.99366 1.28067 8.18713 1.08601 8.42506 1.1009C9.63932 1.17688 10.8148 1.57258 11.8306 2.25134C12.9664 3.01022 13.8516 4.08884 14.3743 5.35081C14.897 6.61278 15.0338 8.00142 14.7673 9.34111C14.5008 10.6808 13.8431 11.9114 12.8772 12.8773C11.9113 13.8431 10.6807 14.5009 9.34102 14.7674C8.00132 15.0339 6.61269 14.8971 5.35072 14.3744C4.08875 13.8517 3.01013 12.9665 2.25125 11.8307C1.57249 10.8149 1.17679 9.63941 1.10081 8.42515C1.08592 8.18722 1.28058 7.99375 1.51897 7.99375H7.99366V1.51907Z"
        />
      </svg>
    );
  }
);

StatusReady.displayName = 'StatusReady';

export { StatusReady };
